module.exports = __webpack_public_path__ + "static/media/purse.a1529ab7.svg";